var core = module.exports = {version: '2.0.3'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef


//////////////////
// WEBPACK FOOTER
// ./~/react-helmet/~/core-js/modules/_core.js
// module id = 39
// module chunks = 0